<template>
  <div class="users-list md:w-2/3 mx-auto fixed-draggable-dynamic-table-wrapper-height semi-box-border-y">

    <draggable-dynamic-table ref="termsListTable"
                             :columns="columnsLabel"
                             :options="options"
                             @column:select="consoleLog($event)"
                             @filter:remove="setFilters($event)"
                             @filter:set="setFilters($event)"
                             @sort:set="setSort($event)"
                             @load:more="getTerms()"
                             @row:clicked="showTerm"
                             v-model="data"/>

    <!-- insert new user prompt -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="insertNewTermPromptStatus"
      @close="insertNewTermPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('insertTermBTN')">
              <custom-icon icon="SAVE" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('terms.insert.title') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="insertNewTermPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content p-2">
        <template>
          <keep-alive>
            <insert-term :in-modal="true" @insert="reloadCourtsList"/>
          </keep-alive>
        </template>
        <!--<cash-boxes-opening-balance v-if="header.suggestPromptComponent === 'cashBoxes'"/>-->
      </div>

    </vs-prompt>

    <!-- show user details prompt -->
    <vs-prompt
      class="medium-prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="showTermPromptStatus"
      @close="showTermPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div v-if="checkUserPermissions('term.update')" @click="editUserPromptStatus = true">
              <custom-icon icon="EDIT" color="warning"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
<!--            {{ $t('terms.profile.dynamicTitle', {name: selectedUser.name}) }}-->
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="showTermPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content">
        <template>
          <keep-alive>
            <term-profile :term-id="selectedUser.id"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <!-- edit user prompt -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="editUserPromptStatus"
      @close="editUserPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('EditUserBTN')">
              <custom-icon icon="SAVE" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('terms.edit.dynamicTitle', {name: selectedUser.name}) }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="editUserPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content">
        <template>
          <keep-alive>
            <edit-term :term-id="selectedUser.id" @edit="reloadCourtsList"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <button id="insertNewCourt" v-show="false" @click="insertNewTermPromptStatus = true"/>
  </div>
</template>

<script>
import DraggableDynamicTable from '@/components/draggableDynamicTable/draggableDynamicTable'
import {getTerms} from '@/http/requests/terms'
import {checkUserPermissions, getAvatarUrl} from '../../../../assets/js/functions'
import InsertTerm from '../insert/insertTerm'
import EditTerm from '../edit/editTerm'
import TermProfile from '../profile/termProfile'
import CustomIcon from '../../../../components/customIcon/customIcon'

export default {
  name: 'TermsList',
  metaInfo () {
    return {
      title: this.$t('terms.list.title')
    }
  },
  components: {
    CustomIcon,
    TermProfile,
    EditTerm,
    InsertTerm,
    DraggableDynamicTable
  },
  data () {
    return {
      requestSent: false,
      insertNewTermPromptStatus: false,
      showTermPromptStatus: false,
      editUserPromptStatus: false,
      loadingTimer: 0,
      options: {
        id: 'termsListTable',
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'endTime',
          i18n: 'terms.list.table.header.endTime',
          width: 'calc((100% - 70px) / 4)',
          minWidth: 150,
          align: 'center',
          filter: false,
          filterType: 'date',
          sortable: true
          // locked: true
        },
        {
          field: 'startTime',
          i18n: 'terms.list.table.header.startTime',
          width: 'calc((100% - 70px) / 4)',
          minWidth: 150,
          align: 'center',
          filter: false,
          filterType: 'date',
          sortable: true
          // locked: true
        },
        {
          field: 'name',
          i18n: 'terms.list.table.header.name',
          width: 'calc((100% - 70px) / 4 * 2)',
          minWidth: 200,
          sortable: true,
          // locked: true,
          filter: false,
          filterTypes: [
            {
              icon: 'search',
              name: 'شامل شود',
              i18n: 'draggableTable.filter.types.search',
              id: 1
            }
          ]
        },
        {
          field: 'row',
          i18n: 'terms.list.table.header.row',
          width: '70px',
          minWidth: 70,
          align: 'center',
          // locked: true,
          // sortable: true,
          footer: {
            /*type: 'auto-counter'*/
          }
        }
      ],
      data: [],
      filters: [],
      sorts: ['order[0]=created_at,asc'],
      selectedUser: {},
      page: 1,
      endedList: false,
      actions: [
        {
          toolbar: [
            {
              id: 'insertNewCourt',
              icon: 'icon-plus',
              iconPack: 'feather',
              color: 'success',
              permission: 'term.create'
            }
          ],
          leftToolbar: [
            // {
            //   id: 'printTable',
            //   // i18n: 'draggableDynamicTable.actions.print',
            //   icon: 'icon-printer',
            //   iconPack: 'feather'
            // },
            // {
            //   id: 'downloadTable',
            //   // i18n: 'draggableDynamicTable.actions.download',
            //   icon: 'icon-download',
            //   iconPack: 'feather'
            // },
            {
              id: {name: 'termsTrash'},
              type: 'link',
              icon: 'icon-trash',
              iconPack: 'feather',
              permission: 'term.delete'
            },
            // {
            //   id: 'settingTable',
            //   icon: 'icon-settings',
            //   iconPack: 'feather'
            // }
          ]
        }
      ]
    }
  },
  created () {

    setTimeout(() => {
      this.$store.dispatch('updateNavbarActions', this.actions[0])
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
      this.$store.dispatch('updateContentNavbarClass', ' md:w-2/3 mx-auto')
    }, 50)

    this.getTerms()
  },
  methods: {
    checkUserPermissions(permission) {
      return checkUserPermissions(permission)
    },
    getTerms () {
      if (!this.requestSent) {
        this.requestSent = true

        clearTimeout(this.loadingTimer)
        this.loadingTimer = setTimeout(() => {
          if (!this.endedList) {
            if (this.$refs.termsListTable && this.data.length === 0) {
              this.$refs.termsListTable.loadMoreStatus = 'FirstLoad'
            } else if (this.$refs.termsListTable && this.data.length > 0) {
              this.$refs.termsListTable.loadMoreStatus = 'Loading'
            }

            getTerms(this.page, this.filters, this.sorts).then((res) => {
              this.endedList = res.data.data.length === 0
              res.data.data.forEach((term) => {

                this.data.push({
                  row: this.data.length + 1,
                  id: term.id,
                  registryDate: term.created_at,
                  gender: term.gender === 1 ? this.$t('genderTypes.man') : this.$t('genderTypes.woman'),
                  name: term.name || '',
                  startTime: term.start_time || '',
                  endTime: term.end_time || ''
                })
              })

              this.page = res.data.pagination.current_page + 1
              if (res.data.pagination.current_page === 1) {
                const row_index = this.columnsLabel.map((e) => {
                  return e.field
                }).indexOf('row')
                this.columnsLabel[row_index].footer.value = res.data.pagination.total
              }

              if (this.$refs.termsListTable) this.$refs.termsListTable.loadMoreStatus = ''

              this.requestSent = false
            })
              .catch(() => {
                if (this.$refs.termsListTable) this.$refs.termsListTable.loadMoreStatus = 'Danger'

                this.requestSent = false
              })
          } else {

            this.requestSent = false
          }
        }, 400)
      }
    },
    showTerm (user) {
      this.selectedUser = user
      this.showTermPromptStatus = true
    },
    setFilters (filters) {
      const filters_list = []
      Object.keys(filters).forEach((key) => {
        switch (key) {

        case 'name':
          if (filters[key].search !== '') filters_list.push(`full_name=${  filters[key].search}`)
          break

        case 'registryDate':
          if (filters[key].search !== '') filters_list.push(`created_at=${  filters[key].search}`)
          break
        }
      })
      filters_list.push('characters=1')

      this.data = []
      this.page = 1
      this.endedList = false
      this.filters = filters_list
      this.getTerms()
    },
    setSort (columns) {
      const sorts_list = []
      Object.keys(columns).forEach((key) => {
        switch (key) {

        case 'row':
          sorts_list.push(`order[0]=id,${  columns[key] ? 'desc' : 'asc'}`)
          break

        case 'name':
          sorts_list.push(`order[0]=name,${  columns[key] ? 'desc' : 'asc'}`)
          break

        case 'startTime':
          sorts_list.push(`order[0]=start_time,${  columns[key] ? 'desc' : 'asc'}`)
          break

        case 'endTime':
          sorts_list.push(`order[0]=start_time,${  columns[key] ? 'desc' : 'asc'}`)
          break
        }
      })

      if (!sorts_list.length) sorts_list.push('order[0]=created_at,desc')

      this.data = []
      this.page = 1
      this.endedList = false
      this.sorts = sorts_list
      this.getTerms()
    },
    reloadCourtsList () {
      this.data = []
      this.page = 1
      this.endedList = false
      this.getTerms()
      this.editUserPromptStatus = false
      this.insertNewTermPromptStatus = false
      this.showTermPromptStatus = false
    },
    consoleLog () {
      // console.log(event)
    },
    handleClick (id) {
      document.getElementById(id).click()
    }
  }
}
</script>

<style scoped>
</style>
